import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button } from 'shards-react'

import RouteLayout from '../../RouteLayout'
import Spinner from '../../common/Spinner'
import { CaptionTable } from '../../common/CaptionTable/CaptionTable'
import { AddEditModal } from './Components'
import {
  commissionListActions,
  commissionDeleteActions,
} from '../../../redux/reducers/Commission/commissionReducer'
import ConfirmModal from '../../common/Confirmation'
import styles from './Commission.module.css'
import moment from 'moment'

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
)


const List = () => {

  const dispatch = useDispatch()
  const history = useHistory()
  const {list, loader} = useSelector(state => state.commission)

  const [modalOpen, setModalOpen] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    dispatch(commissionListActions.commissionListRequestStart())
  }, [dispatch])

  const handleRowClick = (id) => {
    history.push(`/commissions/${id}`)
  }

  const handleDelete = (e, id) => {
    e.stopPropagation()
    setDeleteId(id)
    setConfirmOpen(true)
  }

  const handleDeleteConfirm = () => {
    dispatch(commissionDeleteActions.commissionDeleteRequestStart({ id: deleteId }))
    setConfirmOpen(false)
    setDeleteId(null)
  }


  const dateFormatted = (date) => date ? moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : ''

  const renderRow = (item, index) => (
    <tr key={item.id} onClick={() => handleRowClick(item.id)}>
      <td>{index + 1}</td>
      <td>{dateFormatted(item.date_from)}</td>
      <td>{dateFormatted(item.date_to)}</td>
      <td>{dateFormatted(item.date_to_guk)}</td>
      <td>{item.created_at}</td>
      <td>
        <input
          type="checkbox"
          checked={item.closed === '1'}
          readOnly
          disabled
          onClick={(e) => e.stopPropagation()}
        />
      </td>
      <td className={styles.deleteCell}>
        <button
          className={styles.deleteBtn}
          onClick={(e) => handleDelete(e, item.id)}
          title="Удалить"
        >
          <TrashIcon />
        </button>
      </td>
    </tr>
  )

  return (
    <RouteLayout title={'Аттестационные комиссии'}>
      <Button theme="primary" className="mb-3" onClick={() => setModalOpen(true)}>
        Добавить комиссию
      </Button>

      {loader
        ? <Spinner />
        : (
          <div className={styles.tableBlock}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>№ п/п</th>
                  <th>Дата начала</th>
                  <th>Дата окончания</th>
                  <th>Дата окончания (ГУК)</th>
                  <th>Дата создания</th>
                  <th>Не отображать</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {list.map(renderRow)}
              </tbody>
            </table>
            {!list.length && !loader && <CaptionTable>Список пуст</CaptionTable>}
          </div>
        )
      }

      <AddEditModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        isEdit={false}
      />

      <ConfirmModal
        isOpen={confirmOpen}
        title="Удаление комиссии"
        text="Вы уверены, что хотите удалить комиссию?"
        onConfirm={handleDeleteConfirm}
        onCancel={() => { setConfirmOpen(false); setDeleteId(null) }}
      />
    </RouteLayout>
  )
}

export default List
